import axios from "axios";

export function init(apiBase, apiKey) {
  if (document.querySelector('.module-sondekform')) {

    const urlPath = window.location.pathname.split("/");

    // Handle submission of booking form ------------------- //
    const sondekForm = document.querySelector("form.reserve-sondek");
    sondekForm.addEventListener("submit", function (e) {
      e.preventDefault();

      if (document.querySelector('.reserve-sondek .g-recaptcha-response').value !== "") {
        document.querySelector(".recaptcha-validation-text").style.visibility =
          "hidden";

        document.querySelector(".overlay").classList.add("-white");
        document.querySelector(".overlay").classList.add("-visible");

        const formData = new FormData();

        let apiEndpoint;

        // retailer demo booking

        apiEndpoint = "users/subscriptions/lp12-50";
        const emailAddress = sondekForm.querySelector('input[name="email"]').value;

        formData.append("email", emailAddress);

        // fbq("trackCustom", "BookADemo", { storeId: storeId, emailAddress: emailAddress });

        //   gtag("event", "BookADemo", {
        //     event_category: "Forms",
        //     event_action: "Submit",
        //     event_label: "BookADemo",
        //   });

        formData.append(
          "fullName",
          sondekForm.querySelector('input[name="fullName"]').value
        );

        formData.append(
          "country",
          sondekForm.querySelector('select[name="country"]').value
        );

        formData.append(
          "postCode",
          sondekForm.querySelector('input[name="postCode"]').value
        );

        formData.append(
          "phoneNumber",
          window.phoneInput.getNumber()
        );

        formData.append(
          "ownsLinnHifi",
          sondekForm.querySelector('select[name="ownsLinnHifi"]').value === 'Yes'
        );

        formData.append(
          "ownsCompetitorHifi",
          sondekForm.querySelector('select[name="ownsCompetitorHifi"]').value === 'Yes'
        );

        formData.append(
          "subscribed",
          !sondekForm.querySelector('input[name="subscribed"]').checked
        );

        formData.append(
          "g-recaptcha-response",
          document.querySelector('.reserve-sondek .g-recaptcha-response').value
        );

        axios({
          method: "post",
          url: apiBase + apiEndpoint,
          data: formData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
          .then(function (response) {
            //success
            document.querySelector(".overlay").classList.remove("-white");
            document.querySelector(".overlay").classList.remove("-visible");
            sondekForm.remove();
            document.querySelector("p.thanks").classList.remove("-hidden");
            document
              .querySelector(".module-sondekform .contents")
              .scrollIntoView();
          })
          .catch(function (response) {
            console.log(response);
          });
      } else {
        document.querySelector(".recaptcha-validation-text").style.visibility =
          "visible";
      }
    });
  }
}
